/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import { Btn } from 'components/buttons'
import { Checkmark } from '@entrata/portals-common/lib/icons'

import styled from '@emotion/styled'
import { mix } from 'polished'

const StyledBtn = styled(Btn)`
  ${({ selected, theme }) =>
    selected &&
    `
    background-color: ${theme.secondary.base};
    border-color: ${theme.secondary.base};
    color: white;

    &:focus,
    &:hover:not([disabled]) {
      background-color: ${mix(0.75, theme.secondary.base, '#fff')};
    }
  `}
`

const ToggleBtn = ({ children, selected, ...rest }) => (
  <StyledBtn {...rest} selected={selected} appearance='secondary' block>
    {selected ? <Checkmark /> : children}
  </StyledBtn>
)

ToggleBtn.propTypes = {
  children: PropTypes.node.isRequired,
  selected: PropTypes.bool,
}

export default ToggleBtn
